module.exports = __webpack_public_path__ + "img/sourire-ealigner-2.13f41d35.png";